import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogIn, AlertCircle } from "lucide-react";
import "./Login.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showError, setShowError] = useState(false);
  const { login, error, isAuthenticated, clearError } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Get the redirect path from location state or default to home page
  const from = location.state?.from || "/";

  // Clear error on component mount
  useEffect(() => {
    clearError();
  }, [clearError]);

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, from]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form inputs
    if (!email || !password) {
      setShowError(true);
      setTimeout(() => setShowError(false), 3000);
      return;
    }

    // Attempt login
    const success = await login(email, password);

    if (success) {
      navigate(from, { replace: true });
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <LogIn size={30} className="login-icon" />
          <h1 className="login-title">Admin Login</h1>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          {/* Show error message if authentication fails */}
          {error && (
            <div className="login-error">
              <AlertCircle size={18} />
              <span>{error}</span>
            </div>
          )}

          {/* Show form validation error */}
          {showError && (
            <div className="login-error">
              <AlertCircle size={18} />
              <span>Please enter both email and password.</span>
            </div>
          )}

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
            />
          </div>

          <button type="submit" className="login-button">
            <LogIn size={18} />
            <span>Log In</span>
          </button>
        </form>

        <div className="login-footer">
          <p>This area is restricted to administrators only.</p>
          <a href="/" className="back-link">
            Return to Home
          </a>
        </div>
      </div>
    </div>
  );
};

export default Login;
